import { render, staticRenderFns } from "./OrderfulfillmentSettingDefaultNew.vue?vue&type=template&id=73452312&scoped=true"
import script from "./OrderfulfillmentSettingDefaultNew.vue?vue&type=script&lang=js"
export * from "./OrderfulfillmentSettingDefaultNew.vue?vue&type=script&lang=js"
import style0 from "./OrderfulfillmentSettingDefaultNew.vue?vue&type=style&index=0&id=73452312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73452312",
  null
  
)

export default component.exports